<template>
  <v-dialog
    persistent
    v-model="showLinkDialog"
    max-width="750"
    @keydown.esc="closeLinkDialog(false)"
    overlay-opacity="0.9"
    :dark="compColor.isInDarkMode"
    :color="compColor.primeColor"
  >
    <div class="elevation-10 layout-column" style="border-radius: 6px;"
         v-bind:style="{background: compColor.contentFrame}">

      <!-- HEADER -->

      <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
           :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
        {{$t('COMPONENT_DASHBOARD.DOWNLOADS_HEADER_LINK_CONFIRM_DIALOG')}}
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <!-- CONTENT  -->

      <div class="ma-1 px-3 py-5 layout-row elevation-3" style="border-radius: 5px;position: relative;" :style="{'background': compColor.lxExpansion.background}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-avatar tile :color="isDarkMode ? compColor.prime : 'grey lighten-3'">
            <v-icon :color="isDarkMode ? 'white' : compColor.primeColor">info</v-icon>
          </v-avatar>
        </div>

        <div class="flex layout-column layout-align-center-start ml-2" :class="isDarkMode? 'blue-grey--text text--lighten-2' : 'blue-grey--text text--darken-2'">
          <span class="mb-2">{{ $t('COMPONENT_DASHBOARD.DOWNLOADS_TEXT_LINK_CONFIRM_DIALOG_PART1') }}</span>
          <span style="font-weight: bold;font-style: italic;">{{ selectedLink }}</span>
          <span class="mt-2">{{ $t('COMPONENT_DASHBOARD.DOWNLOADS_TEXT_LINK_CONFIRM_DIALOG_PART2') }}</span>
        </div>
      </div>

      <!-- ACTIONS -->

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row layout-align-end-center pa-1">
        <v-btn depressed :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1" @click="closeLinkDialog(true)">
          {{ $t('COMPONENT_DASHBOARD.DOWNLOADS_BUTTON_CONFIRM_LINK') }}
        </v-btn>
        <v-btn depressed :color="'grey'" :dark="isDarkMode" class="white--text text-none" @click="closeLinkDialog(false)">
          {{ $t('buttons.cancel.value') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'LinkDialog',
  props: {
    selectedLink: String,
    showLinkDialog: Boolean
  },

  methods: {
    /**
     * Close dialog and open new browser tab if wished
     *
     * @param linkAccepted
     */
    closeLinkDialog (linkAccepted) {
      if (linkAccepted && this.selectedLink) {
        window.open(this.selectedLink, '_blank').focus()
      }
      this.$emit('close-link-dialog')
    }
  }
}
</script>

